import "./deliveryInfo.scss";

const DeliveryInfo = ({ delivery, confirmDeadline }) => {
    const fullAddress = delivery.postal_code
        ? `[${delivery.postal_code}] ${delivery.address || ""}`
        : (delivery.address || "");

    return (
        <div className="delivery-info">
            {/* 수령인 정보 */}
            <div className="delivery-details">          
              <div className="delivery-name">
              <span>수령인</span>
              <span>{ delivery.name || ""}</span>
              </div>
              <div className="delivery-name">
              <span>연락처</span>
              <span>{ delivery.phone || ""}</span>
              </div>
              {fullAddress && <div className="delivery-address">
                <span>배송 주소 </span>
                <span>{ fullAddress}</span></div>}
              <div className="delivery-courier">
              <span>송장번호</span>
              <span>  { delivery.courier || ""} {delivery.tracking_number || ""}</span>
              </div>
              <div className="delivery-memo">
              <span>배송 메모</span>
              <span>{ delivery.memo || "-"}</span>
              </div>
            </div>

            {confirmDeadline && (
                <div className="confirm-deadline">
                    <span className="deadline-label">구매확정일</span>
                    <span className="deadline-date">{confirmDeadline}</span>
                </div>
            )}
        </div>
    );
};

export default DeliveryInfo;
